import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { ImportProgress } from '~hooks/useCSVImportExport/configs/types';

interface CSVImportProgressProps {
  progress: ImportProgress;
}

export function CSVImportProgress({ progress }: CSVImportProgressProps) {
  const percentComplete =
    progress.total > 0 ? Math.round((progress.completed / progress.total) * 100) : 0;

  return (
    <Box sx={{ width: '100%', py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {t('csv_import_export.progress', {
            completed: progress.completed,
            total: progress.total,
          })}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
          }}
        >
          {percentComplete}%
        </Typography>
      </Box>
      <LinearProgress variant="determinate" value={percentComplete} />
      <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
        <Typography
          variant="body2"
          sx={{
            color: 'success.main',
          }}
        >
          {t('csv_import_export.succeeded', { count: progress.succeeded })}
        </Typography>
        {progress.failed > 0 && (
          <Typography
            variant="body2"
            sx={{
              color: 'error.main',
            }}
          >
            {t('csv_import_export.failed', { count: progress.failed })}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
